module.exports = __webpack_public_path__ + "static/mail-334c66690a4c462824e738f0dbf05029.svg";